const AccessibilityTtsRateEnum = {
	"accessibility-tts-rate-slow": "Rythme lent",
	"accessibility-tts-rate-normal": "Rythme normal",
	"accessibility-tts-rate-fast": "Rythme rapide"
} as const;

export default AccessibilityTtsRateEnum;

export const TtsRateValues: Record<keyof typeof AccessibilityTtsRateEnum, number> = {
	"accessibility-tts-rate-slow": 0.75,
	"accessibility-tts-rate-normal": 1,
	"accessibility-tts-rate-fast": 1.25
};
